/*! LQ NameSpace | Copyright 2015 Loto Quebec Inc. */
/*global jQuery,lq,console*/
/*jshint -W030*/
; (function ($, document, window, lq) {
	'use strict';

    // On ne vise que les cards dans le carrousel 
	$('.card.carrousel').each(function () {
		var cardCarrousel = $(this);
		var primaryColor = cardCarrousel.data('buttonprimarycolor');
		var secondaryColor = cardCarrousel.data('buttonsecondarycolor');

		if (primaryColor && secondaryColor) {
			$('.btnContainer, .progress-bar', this).attr('style', 'background-image: linear-gradient(140deg, ' + primaryColor + ', ' + secondaryColor + ');');
		} else if(primaryColor) {
			$('.btnContainer, .progress-bar', this).attr('style', 'background-color: ' + primaryColor + ';');
		}

		if(cardCarrousel.parents('.fn-carousel').length > 0) {
			//Si Card de carrousel
			$('.btn', this).on("focus mouseenter", function() {
				$(this).css({"background-color": primaryColor || secondaryColor || 'white',
							 "background-clip": "border-box"});
			});
			
			$('.btn', this).on("focusout mouseleave", function() {
				$(this).css({"background-color": "transparent"});
			});
		}

	});
	// Update global scope lq namespace
	window.lq = lq;

	// Auto trigger all self implemented (plugin) functionalities
	lq.load.push(
		"lq.utils",
		[
			'setupCardsCarrousel'
		]
	);

}(jQuery, document, window, (window.lq || {})));